export const DEFAULT_IMAGE_DEMENSION = {
    WIDTH: 200,
    HEIGHT: 200
};

export enum StockStatus {
   INSTOCK,
   OUTSTOCK
};

export const FONT_FAMILIES: {label: string; value: string; group?: string}[] = [
    // ── Custom Fonts (built-in) ──
    {
        label: "Bali Nights",
        value: "BaliNights",
        group: "Custom"
    },
    {
        label: "Family Doodle",
        value: "FamilyDoodle",
        group: "Custom"
    },
    {
        label: "BabyDay",
        value: "BabyDay",
        group: "Custom"
    },
    {
        label: "Delighter",
        value: "Delighter",
        group: "Custom"
    },
    {
        label: "Designer",
        value: "Designer",
        group: "Custom"
    },
    {
        label: "Hello Rainbow Duo",
        value: "HelloRainbowDuo",
        group: "Custom"
    },
    {
        label: "Hello Rainbow Signature",
        value: "HelloRainbowSignature",
        group: "Custom"
    },
    {
        label: "Hello September",
        value: "HelloSeptember",
        group: "Custom"
    },
    {
        label: "Ashley Southine",
        value: "AshleySouthine",
        group: "Custom"
    },
    {
        label: "Itsmehello Regular",
        value: "ItsmehelloRegular",
        group: "Custom"
    },
    {
        label: "Itsmehelloscript Regular",
        value: "ItsmehelloscriptRegular",
        group: "Custom"
    },
    {
        label: "Little Love",
        value: "LittleLove",
        group: "Custom"
    },
    {
        label: "Merry Christmas Joy",
        value: "MerryChristmasJoy",
        group: "Custom"
    },
    {
        label: "Midnight",
        value: "Midnight",
        group: "Custom"
    },
    {
        label: "Night Mountain",
        value: "NightMountain",
        group: "Custom"
    },
    {
        label: "Selebor",
        value: "Selebor",
        group: "Custom"
    },
    {
        label: "Spooky Halloween",
        value: "SpookyHalloween",
        group: "Custom"
    },
    {
        label: "Wicked Halloween",
        value: "WickedHalloween",
        group: "Custom"
    },
    {
        label: "Timelapse",
        value: "Timelapse",
        group: "Custom"
    },
    {
        label: "Thorin",
        value: "Thorin",
        group: "Custom"
    },
    {
        label: "Vintage Capital",
        value: "VintageCapital",
        group: "Custom"
    },
    // ── Sans-Serif ──
    {
        label: "Montserrat",
        value: "Montserrat",
        group: "Sans-Serif"
    },
    {
        label: "Poppins",
        value: "Poppins",
        group: "Sans-Serif"
    },

    {
        label: "Oswald",
        value: "Oswald",
        group: "Sans-Serif"
    },
    {
        label: "Righteous",
        value: "Righteous",
        group: "Sans-Serif"
    },
    {
        label: "Russo One",
        value: "Russo One",
        group: "Sans-Serif"
    },
    // ── Display / Bold ──
    {
        label: "Bebas Neue",
        value: "Bebas Neue",
        group: "Display"
    },
    {
        label: "Bangers",
        value: "Bangers",
        group: "Display"
    },
    {
        label: "Abril Fatface",
        value: "Abril Fatface",
        group: "Display"
    },
    {
        label: "Permanent Marker",
        value: "Permanent Marker",
        group: "Display"
    },

    {
        label: "Boogaloo",
        value: "Boogaloo",
        group: "Display"
    },
    {
        label: "Press Start 2P",
        value: "Press Start 2P",
        group: "Display"
    },
    // ── Script / Handwriting ──
    {
        label: "Pacifico",
        value: "Pacifico",
        group: "Script"
    },
    {
        label: "Great Vibes",
        value: "Great Vibes",
        group: "Script"
    },
    {
        label: "Lobster",
        value: "Lobster",
        group: "Script"
    },

    {
        label: "Sacramento",
        value: "Sacramento",
        group: "Script"
    },
    {
        label: "Allura",
        value: "Allura",
        group: "Script"
    },
    {
        label: "Yellowtail",
        value: "Yellowtail",
        group: "Script"
    },
    // ── Serif / Elegant ──
    {
        label: "Times New Roman",
        value: "Times New Roman",
        group: "Serif"
    },
    {
        label: "DM Serif Display",
        value: "DM Serif Display",
        group: "Serif"
    },
];



export const FONT_DECORS: {label: string; value: string}[] = [
    {
        label: "In nghiêng",
        value: "italic"
    },
    {
        label: "Gạch chân",
        value: "underline"
    },
    {
        label: "Gạch ngang",
        value: "line-through"
    }
];

export const FONT_WEIGHTS: {label: string; value: string}[] = [
    {
        label: "100",
        value: "100"
    },
    {
        label: "200",
        value: "200"
    },
    {
        label: "300",
        value: "300"
    },
    {
        label: "400",
        value: "400"
    },
    {
        label: "500",
        value: "500"
    },
    {
        label: "600",
        value: "600"
    },
    {
        label: "700",
        value: "700"
    },
    {
        label: "800",
        value: "800"
    },
    {
        label: "900",
        value: "900"
    }
]

export const DEFAULT_PRINTED_PRICE = 50000;